import React, { useEffect, useState } from 'react'
import EditDetailStyles from './EditCompanyDetail.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
// import this for redux read write
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'


const EditCompanyDetail = () => {
    // get data from redux
    const name = useSelector((state) => state.globalData.name);
    const count = useSelector((state) => state.globalData.notificationCount);
    const dispatch = useDispatch()
    const location = useLocation()
    const data = location.state

    const navigate = useNavigate()
    const inputRef = React.useRef();

    const [file, setFile] = useState(null)
    const [source, setSource] = React.useState();
    const [previewUrl, setPreviewUrl] = useState('');
    const [fileName, setFileName] = React.useState('');
    const [pdfSelect, setPdfSelect] = useState(false)
    const [companyDetailsHeading, setCompanyDetailsHeading] = useState('')
    const [prevPdfFileName, setPrevPdfFileName] = useState('');

    useEffect(() => {
        if (data) {
            setCompanyDetailsHeading(data.companyDetails?.companyDetailsHeading);
            setPrevPdfFileName(data?.pdfFile || '');
        }
    }, [data]);


    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        setFileName(selectedFile.name);
        setFile(selectedFile);
        setSource(URL.createObjectURL(selectedFile));
        setPdfSelect(true);
    };


    const handleChoose = () => {
        inputRef.current.click();
    };

    const discardPdf = () => {
        setFile(null);
        setSource('');
        setFileName('');
        setPdfSelect(false);
    };


    const handleSubmit = async (event) => {
        event.preventDefault()

        if (!file && companyDetailsHeading === data.companyDetails?.companyDetailsHeading) {
            // If no change in file and companyDetailsHeading, do nothing
            return;
        }

        const formDataObj = new FormData();
        if (file) {
            formDataObj.append('file', file);
        }
        formDataObj.append('companyDetailsHeading', companyDetailsHeading);

        try {
            const [pdfResponse, detailResponse] = await Promise.all([
                file
                    ? axios.post(`${process.env.REACT_APP_COSMOSADMIN}/companydetails/updatePdfbyId/${data.pdfId}`,
                        formDataObj,
                        {
                            headers: {
                                "Content-Type": "application/pdf"
                            },
                        })
                    : Promise.resolve(null),
                axios.post(
                    `${process.env.REACT_APP_COSMOSADMIN}/companydetails/updateCompanyDetails/${data.companyDetails.companyDetailsId}`,
                    { companyDetailsHeading },
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
            ]);

            
            dispatch(setNotificationCount({
                count: count + 1,
            }))

            setPrevPdfFileName(detailResponse.data.pdfFile);

            alert('Detail Updated.')
            discardPdf()
            navigate('/companydetails')
        } catch (error) {
            console.error(error)
        }
    };



    // const handlePdfLink = async (detail) => {
    //     setSelectedCompanyDetail(detail);


    //     if (detail && detail.pdfFile) {
    //         try {
    //             const pdfId = detail.pdfId;
    //             const apiUrl = `${process.env.REACT_APP_COSMOSADMIN}/companydetails/file/${detail.pdfFile}`;

    //             const response = await axios.get(apiUrl, {
    //                 responseType: 'blob' // set the response type to blob
    //             }).catch((err) => {
    //                 console.log('Error downloading or displaying the PDF file')
    //             })

    //             const blob = new Blob([response.data], { type: 'application/pdf' });
    //             const url = URL.createObjectURL(blob);

    //             setPdfUrl(url);

    //         } catch (error) {
    //             console.error('Error downloading or displaying the PDF file', error);
    //             // Display an error message to the user
    //             // For example: setErrorState(true);
    //         }
    //     }
    // };

    // useEffect(() => {
    //     if (data !== null) {

    //         handlePdfLink(data);
    //     }
    // }, [data])




    return (
        <div className={EditDetailStyles.editDetailMain}>
            <div className={EditDetailStyles.editDetailContent}>
                <form action="" className={EditDetailStyles.editDetailForm} onSubmit={handleSubmit} encType='multipart/form-data'>

                    <label className={EditDetailStyles.editDetailFormLabel}>Title</label>
                    <input className={EditDetailStyles.editDetailFormText}
                        type="text"
                        value={companyDetailsHeading}
                        name='companyDetailsHeading'
                        onChange={(event) => setCompanyDetailsHeading(event.target.value)}
                    />
                    {prevPdfFileName && (
                        <p>Previous PDF File: {prevPdfFileName}</p>
                    )}

                    <label className={EditDetailStyles.editDetailFormLabel}>Choose a PDF:</label>

                    {/* <input className={EditDetailStyles.editDetailFormText} style={{ marginTop: '4%' }} type="text" value={data?.pdfFile} name='companyDetailsHeading' onChange={(event) => setCompanyDetailsHeading(event.target.value)} />

                    {
                        pdfUrl !== '' ?
                            <a href={pdfUrl}  >Previous Pdf </a>
                            :
                            <p>Pdf Loading or not There</p>
                    } */}

                    {/* <label className={EditDetailStyles.editDetailFormLabel}>Choose a PDF:</label> */}
                    <div className={EditDetailStyles.ImgInput}>
                        <input
                            ref={inputRef}
                            className={EditDetailStyles.ImgInput_input}
                            type="file"
                            onChange={handleFileChange}
                        />
                        {!source && <button type='button' onClick={handleChoose}>Browse</button>}
                        {source && <iframe src={source} width="100%" height="500px" title="PDF Preview" />}
                        <div className={EditDetailStyles.ImgInput_footer}>
                            {pdfSelect ?
                                <div>
                                    {fileName}
                                    <DeleteForeverOutlinedIcon onClick={discardPdf} sx={{ cursor: 'pointer' }} />
                                </div> :
                                ''}
                        </div>
                    </div>
                    <Button variant='contained' type='submit' className={EditDetailStyles.saveChanges}>Save changes</Button>
                </form>
            </div>
        </div>
    )
}

export default EditCompanyDetail